import RegisterPersonalInfoForm from './register-personal-info-form-container';

export default RegisterPersonalInfoForm;
